import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kphlyejmohszzhqnexpf.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwaGx5ZWptb2hzenpocW5leHBmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwNTQ5MzA5MywiZXhwIjoyMDIxMDY5MDkzfQ.jm_2XhyPvPQjCOybeLwvZhCcoXcVUHRMiDPKh1a06zw'
const supabase = createClient(supabaseUrl, supabaseKey);

export { supabase }